module.exports = __webpack_public_path__ + "img/animaltwo.06ae427c.png";